export enum RestrictionsTarget {
  STOPS = 'stops',
  AREAS = 'areas'
}
